module.exports = "/_next/static/media/Image-2.1d63136f.png";